import IndicadorPrincipal from "./IndicadorPrincipal";

const EsquemaDeAlertas = (props) => {
	const {data} = props;
	return (
		<div className="table-responsive">
			<table className="skeleton alerts">
				<thead>
					<tr>
						<th>Indicadores</th>
						<th colSpan="2">Porcentaje</th>
						<th>Estado</th>
						<th>Editar</th>
					</tr>
				</thead>
				<tbody>
					{data.map((item, index) =>
						<IndicadorPrincipal key={index} item={item} grupo={data}/>
					)}

				</tbody>
			</table>
		</div>
	)
}
export default EsquemaDeAlertas;
